// extracted by mini-css-extract-plugin
module.exports = {"columns":"_6eb00b8e53--columns--1xkql","column":"_6eb00b8e53--column--1zm4Z"};